import { render, staticRenderFns } from "./AppendixClientPolicies.vue?vue&type=template&id=54de9baa"
import script from "./AppendixClientPolicies.vue?vue&type=script&lang=js"
export * from "./AppendixClientPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports